/* global axios */
import ApiClient from './ApiClient';

class ConversationApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  getLabels(conversationID) {
    return axios.get(`${this.url}/${conversationID}/labels`);
  }

  updateLabels(conversationID, labels) {
    return axios.post(`${this.url}/${conversationID}/labels`, { labels });
  }

  createAppointment(conversationID, appointment) {
    return axios.post(`${this.url}/${conversationID}/appointment`, {
      appointment,
    });
  }

  getAppointmentOptions(conversationID) {
    return axios.get(`${this.url}/${conversationID}/appointment/options`);
  }

  getVtigerRecord(conversationID) {
    return axios.get(`${this.url}/${conversationID}/vtiger_record`);
  }

  sendVtigerLead(conversationID) {
    return axios.post(`${this.url}/${conversationID}/vtiger_record`);
  }

  updateVtigerRecord(conversationID, record) {
    return axios.patch(`${this.url}/${conversationID}/vtiger_record`, {
      record,
    });
  }

  getUnreadCounts() {
    return axios.get(`${this.url}/unread_counts`);
  }
}

export default new ConversationApi();
